import { chevronLeft } from './chevronLeft';

export const chevronRight = () => chevronLeft({
  transform: 'rotate(180 4 6)',
});
